/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import authHeader from './auth-header';
import http from './http-common';
import { API_URLU } from '../config/constant';
const getUserById = (id) => {
  return axios.get(API_URLU + 'user/' + id, { headers: authHeader() });
};

const getDaySales = (branch_code, collection_date, cmp_id) => {
  return axios.get(API_URLU + 'day_sales/' + branch_code + '/' + collection_date + '/' + cmp_id, { headers: authHeader() });
};

const getUserSales = (createdBy, status) => {
  return axios.get(API_URLU + 'sales/' + createdBy + '/' + status, { headers: authHeader() });
};

const getAllSales = (status) => {
  return axios.get(API_URLU + 'sales/' + status, { headers: authHeader() });
};

const getPendingSales = (cmp_id, usr_id) => {
  return axios.get(API_URLU + 'pending_sales/' + cmp_id + '/' + usr_id, { headers: authHeader() });
};

const getApprovedSales = (cmp_id) => {
  return axios.get(API_URLU + 'approved-sales/' + cmp_id, { headers: authHeader() });
};

const getUserShops = (id) => {
  return axios.get(API_URLU + 'user_shops/' + id, { headers: authHeader() });
};

const getAllShops = (id) => {
  return axios.get(API_URLU + 'all_shops/' + id, { headers: authHeader() });
};

const getUsers = () => {
  return axios.get(API_URLU + 'user', { headers: authHeader() });
};

const postUser = (data) => {
  return axios.post(API_URLU + 'user', data, { headers: authHeader() });
};

const getCompById = (id) => {
  return axios.get(API_URLU + 'company/' + id, { headers: authHeader() });
};

const getCompanies = () => {
  return axios.get(API_URLU + 'company', { headers: authHeader() });
};

const postComp = (data) => {
  return axios.post(API_URLU + 'company', data, { headers: authHeader() });
};

const getSystemById = (id) => {
  return axios.get(API_URLU + 'system' + id, { headers: authHeader() });
};

const getMaxDate = (cmpid, branch_code) => {
  return axios.get(API_URLU + 'max-date/' + cmpid + '/' + branch_code, { headers: authHeader() });
};

const getSaleStatus = (cmpid, branch_code) => {
  return axios.get(API_URLU + 'sale-status/' + cmpid + '/' + branch_code, { headers: authHeader() });
};

const getPastDays = (status) => {
  return axios.get(API_URLU + 'open-days/' + status, { headers: authHeader() });
};

const getDaysStatus = () => {
  return axios.get(API_URLU + 'check-days', { headers: authHeader() });
};

const getSystems = () => {
  return axios.get(API_URLU + 'system', { headers: authHeader() });
};

const postSystem = (data) => {
  return axios.post(API_URLU + 'system', data, { headers: authHeader() });
};

const postUserComp = (data) => {
  return axios.post(API_URLU + 'ucompany', data, { headers: authHeader() });
};

// const getUserCompbk = (data) => {
//   return axios.get(API_URLU + 'ucompany/', data, { headers: authHeader() });
// };

const getUserComp = (id) => {
  return axios.get(API_URLU + 'user-companies?userId=' + id, { headers: authHeader() });
};

const getSavingsUserComp = (id) => {
  return axios.get(API_URLU + 'savings-user-companies?userId=' + id, { headers: authHeader() });
};

const postUserSystems = (data) => {
  return axios.post(API_URLU + 'user-systems', data, { headers: authHeader() });
};

const getCompSystems = () => {
  return axios.get(API_URLU + 'company-systems', { headers: authHeader() });
};

const getUserCompSystems = () => {
  return axios.get(API_URLU + 'user-company-systems', { headers: authHeader() });
};

const getUserCompUSystems = () => {
  return axios.get(API_URLU + 'user-company-usystems', { headers: authHeader() });
};

const getCustomerById = (id) => {
  return axios.get(API_URLU + 'customer/' + id, { headers: authHeader() });
};

const getCustomerByCmpId = (data) => {
  return axios.get(API_URLU + 'cmp_customer/' + data.id + '/' + data.offset + '/' + data.pageSize, { headers: authHeader() });
};

const getCustomerByCmpIdAndId = (data) => {
  return axios.get(API_URLU + 'cmp_customer-id/' + data.id + '/' + data.nationalId + '/' + data.offset + '/' + data.pageSize, {
    headers: authHeader()
  });
};

const getCustomers = () => {
  return axios.get(API_URLU + 'customer', { headers: authHeader() });
};

const postCustomer = (data) => {
  return axios.post(API_URLU + 'customer', data, { headers: authHeader() });
};

const postSale = (data) => {
  return axios.post(API_URLU + 'icr_sales', data, { headers: authHeader() });
};

const postDay = (data) => {
  return axios.post(API_URLU + 'open-days', data, { headers: authHeader() });
};

const putSale = (id, data) => {
  return axios.put(API_URLU + 'icr_sales/' + id, data, { headers: authHeader() });
};

const putVatRate = (id, data) => {
  return axios.put(API_URLU + 'vat-rates/' + id, data, { headers: authHeader() });
};

const putStdRate = (id, data) => {
  return axios.put(API_URLU + 'standard-rates/' + id, data, { headers: authHeader() });
};

const putGenRate = (id, data) => {
  return axios.put(API_URLU + 'general-rates/' + id, data, { headers: authHeader() });
};

const putIstPeriod = (id, data) => {
  return axios.put(API_URLU + 'ist-periods/' + id, data, { headers: authHeader() });
};

const putIstSuppliers = (id, data) => {
  return axios.put(API_URLU + 'ist-suppliers/' + id, data, { headers: authHeader() });
};

const putDay = (id, data) => {
  return axios.put(API_URLU + 'open-days/' + id, data, { headers: authHeader() });
};

const getSalesByDate = (cmp_id, usr_id, sdate, edate) => {
  return axios.get(API_URLU + 'sales_date/' + cmp_id + '/' + usr_id + '/' + sdate + '/' + edate, { headers: authHeader() });
};

const getAdminSalesByDate = (cmp_id, sdate, edate) => {
  return axios.get(API_URLU + 'admin-datesales/' + cmp_id + '/' + sdate + '/' + edate, { headers: authHeader() });
};

const getSalesByShop = (cmp_id, branch_code, usr_id, first_date, last_date) => {
  return axios.get(API_URLU + 'sales_shop/' + cmp_id + '/' + branch_code + '/' + usr_id + '/' + first_date + '/' + last_date, {
    headers: authHeader()
  });
};

const getAdminSalesByShop = (cmp_id, branch_code, first_date, last_date) => {
  return axios.get(API_URLU + 'admin-shopsales/' + cmp_id + '/' + branch_code + '/' + first_date + '/' + last_date, {
    headers: authHeader()
  });
};

const delSale = (id) => {
  return axios.delete(API_URLU + 'icr_sales/' + id, { headers: authHeader() });
};

const delVatRate = (id) => {
  return axios.delete(API_URLU + 'vat-rates/' + id, { headers: authHeader() });
};

const delStdRate = (id) => {
  return axios.delete(API_URLU + 'standard-rates/' + id, { headers: authHeader() });
};

const delGenRate = (id) => {
  return axios.delete(API_URLU + 'general-rates/' + id, { headers: authHeader() });
};

const delIstProduct = (id) => {
  return axios.delete(API_URLU + 'ist-products/' + id, { headers: authHeader() });
};

const delCashRate = (id) => {
  return axios.delete(API_URLU + 'ist-cashRates/' + id, { headers: authHeader() });
};

const delMarkup = (id) => {
  return axios.delete(API_URLU + 'ist-checkOffMarkup/' + id, { headers: authHeader() });
};

const putCustomer = (id, data) => {
  return axios.put(API_URLU + 'customer/' + id, data, { headers: authHeader() });
};

const getEmployeeById = (id) => {
  return axios.get(API_URLU + 'chr_employee/' + id, { headers: authHeader() });
};

const getEmployeeByUsername = (name) => {
  return axios.get(API_URLU + 'chr_by_username/' + name, { headers: authHeader() });
};

const getEmployees = () => {
  return axios.get(API_URLU + 'chr_employee', { headers: authHeader() });
};

const getPagedEmployees = (offset, pageSize) => {
  return axios.get(API_URLU + 'employee/' + offset + '/' + pageSize, { headers: authHeader() });
};

const postEmployee = (data) => {
  return axios.post(API_URLU + 'employee', data, { headers: authHeader() });
};

const putEmployee = (id, data) => {
  return axios.put(API_URLU + 'employee/' + id, data, { headers: authHeader() });
};

const getClassification = () => {
  return axios.get(API_URLU + 'classification', { headers: authHeader() });
};

const getGeneral = () => {
  return axios.get(API_URLU + 'general', { headers: authHeader() });
};

const postTempBranch = (data) => {
  return axios.post(API_URLU + 'tbranch', data, { headers: authHeader() });
};

const getTempBranch = () => {
  return axios.get(API_URLU + 'tbranch', { headers: authHeader() });
};

const saveInvoice = (invoice) => {
  return axios.post(API_URLU + 'SaveInvoice', invoice, { headers: authHeader() });
};

const getInvoiceInfo = () => {
  return axios.get(API_URLU + 'getInfo', { headers: authHeader() });
};

const getScheduledLeaves = () => {
  return axios.get(API_URLU + 'scheduled_leaves', { headers: authHeader() });
};

const postLeaveSchedule = (data) => {
  return axios.post(API_URLU + 'scheduled_leaves', data, { headers: authHeader() });
};

const getLeaveAccruals = () => {
  return axios.get(API_URLU + 'leave_accruals', { headers: authHeader() });
};

const getLeaveApplications = () => {
  return axios.get(API_URLU + 'leave_applications', { headers: authHeader() });
};

const postLeaveApplication = (data) => {
  return axios.post(API_URLU + 'leave_applications', data, { headers: authHeader() });
};

const getLeaveTransactions = () => {
  return axios.get(API_URLU + 'leave_transactions', { headers: authHeader() });
};

const getLeaveRejections = () => {
  return axios.get(API_URLU + 'leave_rejections', { headers: authHeader() });
};

const getLeaveTypes = () => {
  return axios.get(API_URLU + 'leave_types', { headers: authHeader() });
};

const getReturnDate = (data) => {
  return axios.get(
    API_URLU +
    'return_date?startDate=' +
    data.startDate +
    '&appliedDays=' +
    data.appliedDays +
    '&leaveCode=' +
    data.leaveCode +
    '&cmpId=' +
    data.cmpId,
    { headers: authHeader() }
  );
};

// const uploadFile = (file, onUploadProgress) => {
//   let formData = new FormData();

//   formData.append("file", file);
//   return axios.post(API_URLU + "singleUpload/", formData, { headers: authHeader(), onUploadProgress })}

// const getFiles = () => {
//   return axios.get(API_URLU + "files/", { headers: authHeader() })}

const uploadFile = (file) => {
  let formData = new FormData();

  formData.append('file', file);

  return http.post('/singleUpload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const uploadExcel = (file) => {
  let formData = new FormData();

  formData.append('file', file);

  return http.post('/upload_chr_employees', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

const getFiles = () => {
  return http.get('/files');
};

const updatePass = (data) => {
  return axios.patch(API_URLU + 'changepwd', data, { headers: authHeader() });
};

const updateUser = (data) => {
  return axios.get(
    API_URLU + 'update-user-profile?id=' + data.id + '&longName=' + data.longName + '&email=' + data.email + '&phone=' + data.phone,
    { headers: authHeader() }
  );
};

const updateUserImg = (data) => {
  return axios.get(API_URLU + 'update-user-image?id=' + data.id + '&photoUrl=' + data.photoUrl, { headers: authHeader() });
};

const getStockCodes = (cmp_id) => {
  return axios.get(API_URLU + 'supplier-products/' + cmp_id, { headers: authHeader() });
};

const getCompanyProducts = (cmp_id) => {
  return axios.get(API_URLU + 'company-istproducts/' + cmp_id, { headers: authHeader() });
};

const getCompanySuppliers = (cmp_id) => {
  return axios.get(API_URLU + 'company-istsuppliers/' + cmp_id, { headers: authHeader() });
};

const getProductDetails = (id) => {
  return axios.get(API_URLU + 'ist-products/' + id, { headers: authHeader() });
};

const getSupplierDetails = (id) => {
  return axios.get(API_URLU + 'ist-suppliers/' + id, { headers: authHeader() });
};

const getSupplerProductDetails = (id) => {
  return axios.get(API_URLU + 'ist-supplierProducts/' + id, { headers: authHeader() });
};

const getSupplierStocks = (supCode) => {
  return axios.get(API_URLU + 'company-istsupplierProducts/' + supCode, { headers: authHeader() });
};

const getCompanyStockCodes = (cmpId) => {
  return axios.get(API_URLU + 'company-stockcodes/' + cmpId, { headers: authHeader() });
};

const getCompanyStocks = (cmpId) => {
  return axios.get(API_URLU + 'company-stocks/' + cmpId, { headers: authHeader() });
};

const getQuoteId = (stockCode, pdate, cmpId, puser, cname, cphone, caddress, qtdId, quant) => {
  return axios.get(
    API_URLU +
    'qtn_id?stockCode=' +
    stockCode +
    '&pdate=' +
    pdate +
    '&cmpId=' +
    cmpId +
    '&puser=' +
    puser +
    '&clientName=' +
    cname +
    '&clientPhone=' +
    cphone +
    '&clientAddress=' +
    caddress +
    '&qtdId=' +
    qtdId +
    '&quantity=' +
    quant,
    { headers: authHeader() }
  );
};

const genCombinedQuote = (qhdId, cmpId, pdate, puser) => {
  return axios.get(API_URLU + 'gen-combinedQuote?qhdId=' + qhdId + '&cmpId=' + cmpId + '&pdate=' + pdate + '&user=' + puser, {
    headers: authHeader()
  });
};

const updateStockQuote = (stockCode, pdate, cmpId, puser) => {
  return axios.get(API_URLU + 'update-quote?stockCode=' + stockCode + '&pdate=' + pdate + '&cmpId=' + cmpId + '&user=' + puser, {
    headers: authHeader()
  });
};

const updatePriceList = (stockCode, pdate, cmpId) => {
  return axios.get(API_URLU + 'update-price?stockCode=' + stockCode + '&effDate=' + pdate + '&cmpId=' + cmpId, {
    headers: authHeader()
  });
};

const UpdateAllPrices = (pdate, cmpId) => {
  return axios.get(API_URLU + 'update-price-all?effDate=' + pdate + '&cmpId=' + cmpId, {
    headers: authHeader()
  });
};

const inteGrateWithKct = (cmpId) => {
  return axios.get(API_URLU + 'integrate-with-kct?cmpId=' + cmpId, {
    headers: authHeader()
  });
};

const getQuoteReport = (
  quoteId,
  repFormat,
  companyName,
  clientName,
  clientPhone,
  clientAddress,
  code,
  sname,
  dateOfQuote,
  repName,
  quantity,
  totalCashPrice,
  phyLocation,
  postalAddress,
  town,
  telephone,
  quoteIdz
) => {
  return axios.get(
    API_URLU +
    'pricequote-report?qtnId=' +
    quoteId +
    '&reportFormat=' +
    repFormat +
    '&companyName=' +
    companyName +
    '&clientName=' +
    clientName +
    '&clientPhone=' +
    clientPhone +
    '&clientAddress=' +
    clientAddress +
    '&stockCode=' +
    code +
    '&stockName=' +
    sname +
    '&quoteDate=' +
    dateOfQuote +
    '&repName=' +
    repName +
    '&quantity=' +
    quantity +
    '&totalCashPrice=' +
    totalCashPrice +
    '&phyLocation=' +
    phyLocation +
    '&postalAddress=' +
    postalAddress +
    '&town=' +
    town +
    '&telephone=' +
    telephone +
    '&nonStockCode=' +
    quoteIdz,
    { headers: authHeader() }
  );
};

const getCombQuoteReport = (
  quoteId,
  repFormat,
  companyName,
  clientName,
  clientPhone,
  clientAddress,
  code,
  sname,
  dateOfQuote,
  repName,
  quantity,
  totalCashPrice,
  phyLocation,
  postalAddress,
  town,
  telephone,
  quoteIdz
) => {
  return axios.get(
    API_URLU +
    'pricequote-report?qtnId=' +
    quoteId +
    '&reportFormat=' +
    repFormat +
    '&companyName=' +
    companyName +
    '&clientName=' +
    clientName +
    '&clientPhone=' +
    clientPhone +
    '&clientAddress=' +
    clientAddress +
    '&stockCode=' +
    code +
    '&stockName=' +
    sname +
    '&quoteDate=' +
    dateOfQuote +
    '&repName=' +
    repName +
    '&quantity=' +
    quantity +
    '&totalCashPrice=' +
    totalCashPrice +
    '&phyLocation=' +
    phyLocation +
    '&postalAddress=' +
    postalAddress +
    '&town=' +
    town +
    '&telephone=' +
    telephone +
    '&nonStockCode=' +
    quoteIdz,
    { headers: authHeader() }
  );
};

const getQuoteInfo = (id) => {
  return axios.get(API_URLU + 'price-quotation/' + id, { headers: authHeader() });
};
const delQuote = (user, id) => {
  return axios.get(API_URLU + 'archive-quote?user=' + user + '&qtnId=' + id, { headers: authHeader() });
};

const closePeriod = (id) => {
  return axios.get(API_URLU + 'close-period?periodId=' + id, { headers: authHeader() });
};

const archCombQuote = (user, id) => {
  return axios.get(API_URLU + 'archive-combQuote?user=' + user + '&qhdId=' + id, { headers: authHeader() });
};

const postQuoteHeader = (data) => {
  return axios.post(API_URLU + 'combined-quotation', data, { headers: authHeader() });
};

const postQuoteDetails = (data) => {
  return axios.post(API_URLU + 'quote-details', data, { headers: authHeader() });
};

const postVatRates = (data) => {
  return axios.post(API_URLU + 'vat-rates', data, { headers: authHeader() });
};

const postStandardRates = (data) => {
  return axios.post(API_URLU + 'standard-rates', data, { headers: authHeader() });
};

const postNewPeriod = (data) => {
  return axios.post(API_URLU + 'ist-periods', data, { headers: authHeader() });
};

const postGeneralRates = (data) => {
  return axios.post(API_URLU + 'general-rates', data, { headers: authHeader() });
};

const postIstProducts = (data) => {
  return axios.post(API_URLU + 'ist-products', data, { headers: authHeader() });
};

const postIstSuppliers = (data) => {
  return axios.post(API_URLU + 'ist-suppliers', data, { headers: authHeader() });
};

const putIstProducts = (id, data) => {
  return axios.put(API_URLU + 'ist-products/' + id, data, { headers: authHeader() });
};

const putIstSupplierProducts = (id, data) => {
  return axios.put(API_URLU + 'ist-supplierProducts/' + id, data, { headers: authHeader() });
};

const postIstSupplierProducts = (data) => {
  return axios.post(API_URLU + 'ist-supplierProducts', data, { headers: authHeader() });
};

const putCashRateDetails = (id, data) => {
  return axios.put(API_URLU + 'ist-cashRates/' + id, data, { headers: authHeader() });
};

const postCashRateDetails = (data) => {
  return axios.post(API_URLU + 'ist-cashRates', data, { headers: authHeader() });
};

const putHpDepositDetails = (id, data) => {
  return axios.put(API_URLU + 'ist-hpdepositPercs/' + id, data, { headers: authHeader() });
};

const postHpDepositDetails = (data) => {
  return axios.post(API_URLU + 'ist-hpdepositPercs', data, { headers: authHeader() });
};

const delHpDepositDetails = (id) => {
  return axios.delete(API_URLU + 'ist-hpdepositPercs/' + id, { headers: authHeader() });
};

const putMarkupDetails = (id, data) => {
  return axios.put(API_URLU + 'ist-checkOffMarkup/' + id, data, { headers: authHeader() });
};

const postMarkupDetails = (data) => {
  return axios.post(API_URLU + 'ist-checkOffMarkup', data, { headers: authHeader() });
};

const putDiscountDetails = (id, data) => {
  return axios.put(API_URLU + 'ist-hpdiscounts/' + id, data, { headers: authHeader() });
};

const postDiscountDetails = (data) => {
  return axios.post(API_URLU + 'ist-hpdiscounts', data, { headers: authHeader() });
};

const delDiscountDetails = (id) => {
  return axios.delete(API_URLU + 'ist-hpdiscounts/' + id, { headers: authHeader() });
};

const putInstalMonths = (id, data) => {
  return axios.put(API_URLU + 'ist-instalmonths/' + id, data, { headers: authHeader() });
};

const postInstalMonths = (data) => {
  return axios.post(API_URLU + 'ist-instalmonths', data, { headers: authHeader() });
};

const delInstalMonths = (id) => {
  return axios.delete(API_URLU + 'ist-instalmonths/' + id, { headers: authHeader() });
};

const putMarkupRates = (id, data) => {
  return axios.put(API_URLU + 'ist-hpmarkuprates/' + id, data, { headers: authHeader() });
};

const postMarkupRates = (data) => {
  return axios.post(API_URLU + 'ist-hpmarkuprates', data, { headers: authHeader() });
};

const delMarkupRate = (id) => {
  return axios.delete(API_URLU + 'ist-hpmarkuprates/' + id, { headers: authHeader() });
};

const putMarkupPercs = (id, data) => {
  return axios.put(API_URLU + 'ist-hpmarkuppercs/' + id, data, { headers: authHeader() });
};

const getCombinedQuotes = (qdtId) => {
  return axios.get(API_URLU + 'get-combinedQuotes/' + qdtId, { headers: authHeader() });
};

const listSingleQuoutes = () => {
  return axios.get(API_URLU + 'list-singleQuotes', { headers: authHeader() });
};

const listCombinedQuoutes = (cmpId) => {
  return axios.get(API_URLU + 'list-combinedQuotes/' + cmpId, { headers: authHeader() });
};

const companyVatRates = (cmpId) => {
  return axios.get(API_URLU + 'company-vats/' + cmpId, { headers: authHeader() });
};

const companyStdRates = (cmpId) => {
  return axios.get(API_URLU + 'company-standardRates/' + cmpId, { headers: authHeader() });
};

const companyGenRates = (cmpId) => {
  return axios.get(API_URLU + 'company-generalRates/' + cmpId, { headers: authHeader() });
};
const currentPeriods = (cmpId) => {
  return axios.get(API_URLU + 'company-currentperiods/' + cmpId, { headers: authHeader() });
};
const pastPeriods = (cmpId) => {
  return axios.get(API_URLU + 'company-pastperiods/' + cmpId, { headers: authHeader() });
};

const allPeriods = (cmpId) => {
  return axios.get(API_URLU + 'get-periods-vw?cmpId=' + cmpId, { headers: authHeader() });
};

const checkVatDates = (cmpId, startDate, endDate) => {
  return axios.get(API_URLU + 'check-vatDates?cmpId=' + cmpId + '&startDate=' + startDate + '&endDate=' + endDate, {
    headers: authHeader()
  });
};

const getCombinedSingle = (stockCode) => {
  return axios.get(API_URLU + 'combined-single?stockCode=' + stockCode, { headers: authHeader() });
};

const getCompanyTariffPeriods = (cmpId) => {
  return axios.get(API_URLU + 'tariff-periods?cmpId=' + cmpId, { headers: authHeader() });
};

const getTariffCashRates = (trpId) => {
  return axios.get(API_URLU + 'ist-trpCashRates/' + trpId, { headers: authHeader() });
};

const getCheckOffMarkupPercs = (trpId) => {
  return axios.get(API_URLU + 'ist-companyCheckOffMarkup/' + trpId, { headers: authHeader() });
};

const getTrpDiscounts = (trpId) => {
  return axios.get(API_URLU + 'ist-hpTrpdiscounts/' + trpId, { headers: authHeader() });
};

const getTrpInstalMonths = (trpId) => {
  return axios.get(API_URLU + 'ist-trpinstalmonths/' + trpId, { headers: authHeader() });
};

const getHpMarkupRates = (trpId) => {
  return axios.get(API_URLU + 'ist-trphpmarkuprates/' + trpId, { headers: authHeader() });
};

const getHpMarkupPercs = (trpId) => {
  return axios.get(API_URLU + 'ist-trphpmarkuppercs/' + trpId, { headers: authHeader() });
};

const getDiscountDetails = (id) => {
  return axios.get(API_URLU + 'ist-hpdiscounts/' + id, { headers: authHeader() });
};

const getInstalMonthsDetails = (id) => {
  return axios.get(API_URLU + 'ist-instalmonths/' + id, { headers: authHeader() });
};

const getRateDetails = (id) => {
  return axios.get(API_URLU + 'ist-cashRates/' + id, { headers: authHeader() });
};

const getHPDepositDetails = (id) => {
  return axios.get(API_URLU + 'ist-hpdepositPercs/' + id, { headers: authHeader() });
};

const getMarkupPercDetails = (id) => {
  return axios.get(API_URLU + 'ist-checkOffMarkup/' + id, { headers: authHeader() });
};

const closeTariffPeriod = (cmpId, pdate, user) => {
  return axios.get(API_URLU + 'close-tariffperiod?cmpId=' + cmpId + '&pdate=' + pdate + '&user=' + user, { headers: authHeader() });
};

const getTrpHpDeposit = (trpId) => {
  return axios.get(API_URLU + 'ist-hpTrpdepositPercs/' + trpId, { headers: authHeader() });
};

const getMarkupDetails = (rateId) => {
  return axios.get(API_URLU + 'ist-hpmarkuprates/' + rateId, { headers: authHeader() });
};

const getMarkupPerc = (rateId) => {
  return axios.get(API_URLU + 'ist-hpmarkuppercs/' + rateId, { headers: authHeader() });
};

const copyPeriods = (cmpId, trpId, pUser, pDate) => {
  return axios.get(API_URLU + 'copy-periods?cmpId=' + cmpId + '&trpId=' + trpId + '&pUser=' + pUser + '&pDate=' + pDate, {
    headers: authHeader()
  });
};

const getProductHist = (id) => {
  return axios.get(API_URLU + 'ist-productsHist/' + id, { headers: authHeader() });
};

const getPriceCataloq = (periodY) => {
  return axios.get(API_URLU + 'get-price-catalogue?periodYear=' + periodY, { headers: authHeader() });
};

const getStockCatalogue = (stockCode) => {
  return axios.get(API_URLU + 'get-stock-catalog?stockCode=' + stockCode, { headers: authHeader() });
};

const getCataloguePeriods = () => {
  return axios.get(API_URLU + 'get-catalog-periods', { headers: authHeader() });
};

const getJointYn = (stockCode, cmpId) => {
  return axios.get(API_URLU + 'is-jointStock?stockCode=' + stockCode + '&cmpId=' + cmpId, { headers: authHeader() });
};

const getJointStockCodes = (stockCode, cmpId) => {
  return axios.get(API_URLU + 'joint-stocks?stockCode=' + stockCode + '&cmpId=' + cmpId, { headers: authHeader() });
};

const getActiveStocks = (cmpId, pDate) => {
  return axios.get(API_URLU + 'active-stocks?cmpId=' + cmpId + '&pDate=' + pDate, { headers: authHeader() });
};

const getJointStocks = (cmpId, pDate, stockCode) => {
  return axios.get(API_URLU + 'attach-joint-stocks?cmpId=' + cmpId + '&pDate=' + pDate + '&stockCode=' + stockCode, {
    headers: authHeader()
  });
};

const addJointStocks = (cmpId, jointStockCode, stockCode, pAction) => {
  return axios.get(
    API_URLU + 'add-joint-stock?cmpId=' + cmpId + '&jointStockCode=' + jointStockCode + '&stockCode=' + stockCode + '&pAction=' + pAction,
    { headers: authHeader() }
  );
};

const getMinDate = (cmpId) => {
  return axios.get(API_URLU + 'min-date?cmpId=' + cmpId, { headers: authHeader() });
};

const getStockCheckOff = (stockCode) => {
  return axios.get(API_URLU + 'stock-checkoff?stockCode=' + stockCode, { headers: authHeader() });
};

const getSupplierPriceList = (cmpId, supCode) => {
  return axios.get(API_URLU + 'supplier-price-list?cmpId=' + cmpId + '&supCode=' + supCode, { headers: authHeader() });
};

const getSupplierPastPriceList = (cmpId, supCode, stockCode) => {
  return axios.get(API_URLU + 'supplier-pastprice-list?cmpId=' + cmpId + '&supCode=' + supCode + '&stockCode=' + stockCode, {
    headers: authHeader()
  });
};

const updatePriceCatalogue = (data) => {
  return axios.get(
    API_URLU +
    'update-price-catalogue?periodYear=' +
    data.periodYear +
    '&periodMonth=' +
    data.periodMonth +
    '&pDate=' +
    data.pDate +
    '&cmpId=' +
    data.cmpId +
    '&username=' +
    data.username,
    {
      headers: authHeader()
    }
  );
};

const addNewPriceListItem = (data) => {
  return axios.get(
    API_URLU +
    'add-new-stock-pricelist?cmpId=' +
    data.cmpId +
    '&stockCode=' +
    data.stockCode +
    '&pDate=' +
    data.pDate +
    '&combinedSingle=' +
    data.combinedSingle +
    '&pUser=' +
    data.pUser,
    {
      headers: authHeader()
    }
  );
};

const getUserRights = (data) => {
  return axios.get(API_URLU + 'userRights?sstId=' + data.sstId + '&username=' + data.username, {
    headers: authHeader()
  });
};

const approveVATRates = (data) => {
  return axios.get(
    API_URLU +
    'approve-vat?approvedYN=' +
    data.approvedYN +
    '&approvedBy=' +
    data.approvedBy +
    '&approvedDate=' +
    data.approvedDate +
    '&id=' +
    data.id,
    {
      headers: authHeader()
    }
  );
};

const approveSTDRates = (data) => {
  return axios.get(
    API_URLU +
    'approve-std?approvedYN=' +
    data.approvedYN +
    '&approvedBy=' +
    data.approvedBy +
    '&approvedDate=' +
    data.approvedDate +
    '&id=' +
    data.id,
    {
      headers: authHeader()
    }
  );
};

const approveGENRates = (data) => {
  return axios.get(
    API_URLU +
    'approve-gen?approvedYN=' +
    data.approvedYN +
    '&approvedBy=' +
    data.approvedBy +
    '&approvedDate=' +
    data.approvedDate +
    '&id=' +
    data.id,
    {
      headers: authHeader()
    }
  );
};

const approvePeriod = (data) => {
  return axios.get(
    API_URLU +
    'approve-period?approvedYN=' +
    data.approvedYN +
    '&approvedBy=' +
    data.approvedBy +
    '&approvedDate=' +
    data.approvedDate +
    '&id=' +
    data.id,
    {
      headers: authHeader()
    }
  );
};

const approveStock = (data) => {
  return axios.get(
    API_URLU +
    'approve-stock?approvedYN=' +
    data.approvedYN +
    '&approvedBy=' +
    data.approvedBy +
    '&approvedDate=' +
    data.approvedDate +
    '&id=' +
    data.id +
    '&cmpId=' +
    data.cmpId,
    {
      headers: authHeader()
    }
  );
};

const clearStockPrices = (data) => {
  return axios.get(API_URLU + 'clear-stock-prices?periodYear=' + data.periodY + '&periodMonth=' + data.periodM, {
    headers: authHeader()
  });
};

const updateStockPrices = (data) => {
  return axios.get(API_URLU + 'update-stock-prices?cmpId=' + data.cmpId + '&periodYear=' + data.periodY + '&periodMonth=' + data.periodM, {
    headers: authHeader()
  });
};

const updateTariffPeriod = (data) => {
  return axios.get(API_URLU + 'update-tariff-period?id=' + data.id + '&startdate=' + data.startdate + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const approvetariffPeriod = (data) => {
  return axios.get(API_URLU + 'approve-tariff-period-proc?id=' + data.id + '&username=' + data.username + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const approveCashRate = (data) => {
  return axios.get(API_URLU + 'approve-cashrate?rateId=' + data.id + '&pUser=' + data.username, {
    headers: authHeader()
  });
};

const approveCheckOff = (data) => {
  return axios.get(API_URLU + 'approve-checkoff?rateId=' + data.id + '&pUser=' + data.username, {
    headers: authHeader()
  });
};

const genCombQuoteHeader = (data) => {
  return axios.get(
    API_URLU +
    'gen-comb-non-stock-header?cmpId=' +
    data.cmpId +
    '&supName=' +
    data.supName +
    '&user=' +
    data.user +
    '&quoteDate=' +
    data.quoteDate +
    '&weight=' +
    data.weight +
    '&solarPanel=' +
    data.solarPanel +
    '&solarComponent=' +
    data.solarComponent +
    '&discountPerc=' +
    data.discountPerc +
    '&stockName=' +
    data.stockName,
    {
      headers: authHeader()
    }
  );
};
const genCombQuoteNoneStockDetails = (data) => {
  return axios.get(
    API_URLU +
    'gen-comb-non-stock-details?cmpId=' +
    data.cmpId +
    '&csqId=' +
    data.csqId +
    '&stockName=' +
    data.stockName +
    '&supplierPrice=' +
    data.supplierPrice +
    '&vatableYn=' +
    data.vatableYn +
    '&vatRate=' +
    data.vatRate +
    '&createdBy=' +
    data.createdBy,
    {
      headers: authHeader()
    }
  );
};
const genNoneStockQuote = (data) => {
  return axios.get(
    API_URLU +
    'none-stock-quote?stockName=' +
    data.stockName +
    '&supplierName=' +
    data.supplierName +
    '&weight=' +
    data.weight +
    '&supplierPrice=' +
    data.supplierPrice +
    '&saleVatRate=' +
    data.saleVatRate +
    '&discountPerc=' +
    data.discountPerc +
    '&solarPanelYn=' +
    data.solarPanelYn +
    '&solarComponentYn=' +
    data.solarComponentYn +
    '&pDate=' +
    data.pDate +
    '&cmpId=' +
    data.cmpId +
    '&username=' +
    data.username,
    {
      headers: authHeader()
    }
  );
};

const genCombNoneStockQuote = (data) => {
  return axios.get(
    API_URLU +
    'gen-comb-non-stock-quote?stockName=' +
    data.stockName +
    '&supplierName=' +
    data.supplierName +
    '&weight=' +
    data.weight +
    '&supplierPrice=' +
    data.supplierPrice +
    '&saleVatRate=' +
    data.saleVatRate +
    '&discountPerc=' +
    data.discountPerc +
    '&solarPanelYn=' +
    data.solarPanelYn +
    '&solarComponentYn=' +
    data.solarComponentYn +
    '&pDate=' +
    data.pDate +
    '&cmpId=' +
    data.cmpId +
    '&username=' +
    data.username +
    '&csqId=' +
    data.csqId,
    {
      headers: authHeader()
    }
  );
};

const listNonStockQuotes = (id) => {
  return axios.get(API_URLU + 'get-none-stock-quotes?nonStockCode=' + id, { headers: authHeader() });
};

const listCombNonStockQuotes = (id) => {
  return axios.get(API_URLU + 'get-comb-none-stock-quotes?csqId=' + id, { headers: authHeader() });
};

const getActiveEndDate = (cmpId) => {
  return axios.get(API_URLU + 'active_enddate?cmpId=' + cmpId, { headers: authHeader() });
};

const getMenuLevels = (data) => {
  return axios.get(API_URLU + 'get-menusbk?sstId=' + data.sstId + '&accessId=' + data.accessId + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getAddTempItem = (id) => {
  return axios.get(API_URLU + 'add-temp-stock?stockCode=' + id, {
    headers: authHeader()
  });
};

const getPoH = () => {
  return axios.get(API_URLU + 'po-headers', { headers: authHeader() });
};

const getPoHVW = (data) => {
  return axios.get(API_URLU + 'po-headervw?cmpId=' + data.cmpId + '&userId=' + data.userId + '&approvalStatus=' + data.approvalStatus, {
    headers: authHeader()
  });
};

const getReqH = (data) => {
  return axios.get(API_URLU + 'req-headersvw?userId=' + data.userId + '&cmpId=' + data.cmpId, { headers: authHeader() });
};

const getPoD = (id) => {
  return axios.get(API_URLU + 'po-details-vw?phdId=' + id, { headers: authHeader() });
};

const getReqD = (id) => {
  return axios.get(API_URLU + 'req-details-vw?rqhId=' + id, { headers: authHeader() });
};

const getPolNo = (data) => {
  return axios.get(
    API_URLU +
    'getPolnumber?cmpId=' +
    data.cmpId +
    '&transType=' +
    data.transType +
    '&branchCode=' +
    data.branchCode +
    '&transDate=' +
    data.transDate,
    { headers: authHeader() }
  );
};

const postPoH = (data) => {
  return axios.post(API_URLU + 'po-headers', data, { headers: authHeader() });
};

const postPoD = (data) => {
  return axios.post(API_URLU + 'po-details', data, { headers: authHeader() });
};

const getReqSummary = (data) => {
  return axios.get(API_URLU + 'requisition-summary/' + data.year + '/' + data.usrId, { headers: authHeader() });
};

const getPoSummary = (data) => {
  return axios.get(API_URLU + 'po-summary/' + data.year + '/' + data.usrId, { headers: authHeader() });
};

const getPohApproval = (data) => {
  return axios.get(
    API_URLU +
    'approve-poh?username=' +
    data.username +
    '&approvedDate=' +
    data.approvedDate +
    '&phdId=' +
    data.phdId +
    '&cmpId=' +
    data.cmpId +
    '&approvalStatus=' +
    data.approvalStatus,
    { headers: authHeader() }
  );
};

const updateMialSent = (data) => {
  return axios.get(API_URLU + 'approve-poh-mail?phdId=' + data.phdId + '&cmpId=' + data.cmpId, { headers: authHeader() });
};

const cancelPO = (data) => {
  return axios.get(
    API_URLU +
    'cancel-poh?phdId=' +
    data.phdId +
    '&cmpId=' +
    data.cmpId +
    '&cancellationReason=' +
    data.cancellationReason +
    '&username=' +
    data.username +
    '&cancelledDate=' +
    data.cancelledDate,
    { headers: authHeader() }
  );
};

const getPurchaseReport = (data) => {
  return axios.get(
    API_URLU +
    'purchase-report?reportFormat=' +
    data.reportFormat +
    '&repName=' +
    data.repName +
    '&cmpId=' +
    data.cmpId +
    '&phdId=' +
    data.phdId +
    '&approvedBy=' +
    data.approvedBy +
    '&vendor=' +
    data.vendor +
    '&poNumber=' +
    data.poNumber +
    '&poDate=' +
    data.poDate +
    '&shop=' +
    data.shop +
    '&dispatchCode=' +
    data.dispatchCode +
    '&signUrl=' +
    data.signUrl +
    '&oldOrderNumber=' +
    data.oldOrderNumber,
    {
      headers: authHeader()
    }
  );
};

const postGaaH = (data) => {
  return axios.post(API_URLU + 'gaa-headers', data, { headers: authHeader() });
};

const postGaaD = (data) => {
  return axios.post(API_URLU + 'gaa-details', data, { headers: authHeader() });
};

const getGaaDByGaaNo = (id) => {
  return axios.get(API_URLU + 'gaa-details-gaaNo?gaaNo=' + id, { headers: authHeader() });
};

const getUpdatePoDetails = (data) => {
  return axios.get(
    API_URLU +
    'approve-pod?rqdId=' +
    data.rqdId +
    '&cmpId=' +
    data.cmpId +
    '&quantityApproved=' +
    data.quantityApproved +
    '&approvalComments=' +
    data.approvalComments +
    '&approvalStatus=' +
    data.approvalStatus +
    '&username=' +
    data.username +
    '&approvedDate=' +
    data.approvedDate,
    {
      headers: authHeader()
    }
  );
};

const getPoNotInGaa = (data) => {
  return axios.get(
    API_URLU + 'po-notin-gaa-headervw?cmpId=' + data.cmpId + '&userId=' + data.userId + '&approvalStatus=' + data.approvalStatus,
    {
      headers: authHeader()
    }
  );
};

const getGaaHVW = (data) => {
  return axios.get(API_URLU + 'gaa-headervw?cmpId=' + data.cmpId + '&userId=' + data.userId, {
    headers: authHeader()
  });
};

const getGaaHVWItems = (data) => {
  return axios.get(API_URLU + 'gaa-headervw-items?cmpId=' + data.cmpId + '&userId=' + data.userId + '&poNumber=' + data.poNumber, {
    headers: authHeader()
  });
};

const getUserBranches = (id, id2) => {
  return axios.get(API_URLU + 'get-user_branches?cmpId=' + id + '&userId=' + id2, {
    headers: authHeader()
  });
};

const postGap = (data) => {
  return axios.post(API_URLU + 'gaa-particulars', data, { headers: authHeader() });
};

const getGapItemsByGaaNo = (id) => {
  return axios.get(API_URLU + 'gaa-particulars-gaaNo?gaaNo=' + id, { headers: authHeader() });
};

const postStkTransH = (data) => {
  return axios.post(API_URLU + 'stock-trans-header', data, { headers: authHeader() });
};

const postStkTransD = (data) => {
  return axios.post(API_URLU + 'stock-trans-details', data, { headers: authHeader() });
};

const generateCombinedNonStockQuote = (csqId, user) => {
  return axios.get(API_URLU + 'generate-combined-nonstock-quote?csqId=' + csqId + '&user=' + user, { headers: authHeader() });
};

const getShopTransfers = (data) => {
  return axios.get(
    API_URLU + 'shop-trans-headervw?cmpId=' + data.cmpId + '&userId=' + data.userId + '&approvalStatus=' + data.approvalStatus,
    {
      headers: authHeader()
    }
  );
};

const getShopTransferDetails = (data) => {
  return axios.get(API_URLU + 'shop-trans-detailvw?cmpId=' + data.cmpId + '&sthId=' + data.sthId, {
    headers: authHeader()
  });
};

const getTransferInvoiceReport = (data) => {
  return axios.get(
    API_URLU +
    'transfer-invoice-report?reportFormat=' +
    data.reportFormat +
    '&repName=' +
    data.repName +
    '&cmpId=' +
    data.cmpId +
    '&phdId=' +
    data.phdId +
    '&approvedBy=' +
    data.approvedBy +
    '&vendor=' +
    data.vendor +
    '&poNumber=' +
    data.poNumber +
    '&poDate=' +
    data.poDate +
    '&shop=' +
    data.shop +
    '&Collected_by=' +
    data.Collected_by +
    '&Dispatcher=' +
    data.Dispatcher +
    '&url=' +
    data.url +
    '&oldOrderNumber=' +
    data.oldOrderNumber,
    {
      headers: authHeader()
    }
  );
};

const getSupplierEmail = (data) => {
  return axios.get(API_URLU + 'supplier-emails?supplierCode=' + data.supplierCode + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const sendLpoMail = (data) => {
  return axios.get(API_URLU + 'send-lpo-email?email=' + data.email + '&repName=' + data.repName, {
    headers: authHeader()
  });
};

const saleItems = (data) => {
  return axios.get(API_URLU + 'get-sale-items?cmpId=' + data.cmpId + '&branchCode=' + data.branchCode, {
    headers: authHeader()
  });
};

const postSalesHeader = (data) => {
  return axios.post(API_URLU + 'sale-header', data, { headers: authHeader() });
};

const postSalesDetails = (data) => {
  return axios.post(API_URLU + 'sale-details', data, { headers: authHeader() });
};

const getSalesDetailsBySshId = (id) => {
  return axios.get(API_URLU + 'sale-details-ssh?sshId=' + id, { headers: authHeader() });
};

const postSalesParticular = (data) => {
  return axios.post(API_URLU + 'sale-particulars', data, { headers: authHeader() });
};

const getSalesParticularBySshId = (id) => {
  return axios.get(API_URLU + 'sale-particulars-ssh?sshId=' + id, { headers: authHeader() });
};

const getSalesHeader = (id) => {
  return axios.get(API_URLU + 'cmp-sale-header?cmpId=' + id, { headers: authHeader() });
};

const getReceiptTranCodes = (cmpId) => {
  return axios.get(API_URLU + 'receipt-codes/' + cmpId, { headers: authHeader() });
};

const findPaymentModes = () => {
  return axios.get(API_URLU + 'payment-modes', { headers: authHeader() });
};
const getCustomerCodes = () => {
  return axios.get(API_URLU + 'customer-codes', { headers: authHeader() });
};

const getPolicyInformation = (custCode) => {
  return axios.get(API_URLU + 'policy-information/' + custCode, { headers: authHeader() });
};

const getAddress = (clientNumber) => {
  return axios.get(API_URLU + 'client-address/' + clientNumber, { headers: authHeader() });
};

const getAllBankAccounts = (cmpId) => {
  return axios.get(API_URLU + 'company-accounts/' + cmpId, { headers: authHeader() });
};

const getAllCreditAccounts = (cmpId) => {
  return axios.get(API_URLU + 'credit-accounts/' + cmpId, { headers: authHeader() });
};

const getLinkedCustomerAccounts = (cmpId, custCode) => {
  return axios.get(API_URLU + 'linked-customer-accounts/' + cmpId + '/' + custCode, { headers: authHeader() });
};

const getCustomerSubaccounts = (cmpId, custCode) => {
  return axios.get(API_URLU + 'get-customer-subaccount/' + cmpId + '/' + custCode, { headers: authHeader() });
};

const getDocDetails = (cmpId, tranCode, docDate, auto) => {
  return axios.get(API_URLU + 'doc_number?cmpId=' + cmpId + '&trancode=' + tranCode + '&docdate=' + docDate + '&auto=' + auto, {
    headers: authHeader()
  });
};

const docAvailable = (data) => {
  return axios.get(
    API_URLU +
    'is-doc-number-available?accountYear=' +
    data.accountYear +
    '&tranCode=' +
    data.tranCode +
    '&docNumber=' +
    data.docNumber +
    '&cmpId=' +
    data.cmpId,
    { headers: authHeader() }
  );
};

const postReceiptHeader = (data) => {
  return axios.post(API_URLU + 'receipt', data, { headers: authHeader() });
};

const putReceiptHeader = (id, data) => {
  return axios.put(API_URLU + 'receipt/' + id, data, { headers: authHeader() });
};

const postReceiptDetails = (data) => {
  return axios.post(API_URLU + 'receipt-details', data, { headers: authHeader() });
};

const putReceiptDetails = (id, data) => {
  return axios.put(API_URLU + 'receipt-details/' + id, data, { headers: authHeader() });
};

const getReceiptDetails = (id) => {
  return axios.get(API_URLU + 'receipt-details/' + id, { headers: authHeader() });
};

const getCompanyBanks = (cmpId) => {
  return axios.get(API_URLU + 'customer-banks/' + cmpId, { headers: authHeader() });
};

const getReceiptHeaderApprovalStatus = (cmpId, rhdId) => {
  return axios.get(API_URLU + 'is-header-approved/' + cmpId + '/' + rhdId, { headers: authHeader() });
};

const approveReceiptHeader = (cmpId, rhdId, docDate) => {
  return axios.get(API_URLU + 'approve-receipt-header/' + cmpId + '/' + rhdId + '/' + docDate, { headers: authHeader() });
};

const poReports = (id) => {
  return axios.get(API_URLU + 'po-reports?cmpId=' + id, { headers: authHeader() });
};

const getPoReportDetails = (data) => {
  return axios.get(
    API_URLU + 'po-report-details?cmpId=' + data.cmpId + '&userId=' + data.userId + '&approvalStatus=' + data.approvalStatus,
    {
      headers: authHeader()
    }
  );
};

const getPurchaseReport2 = (data) => {
  return axios.get(
    API_URLU +
    'purchase-report?reportFormat=' +
    data.reportFormat +
    '&repName=' +
    data.repName +
    '&cmpId=' +
    data.cmpId +
    '&userId=' +
    data.userId,
    {
      headers: authHeader()
    }
  );
};

const getSaleTypes = (id) => {
  return axios.get(API_URLU + 'get-sale-type?cmpId=' + id, {
    headers: authHeader()
  });
};

const companyReceipts = (cmpId) => {
  return axios.get(API_URLU + 'get-company-receipts/' + cmpId, { headers: authHeader() });
};

const getSelectedReceiptDetails = (id) => {
  return axios.get(API_URLU + 'get-receipt-by-rhdid/' + id, { headers: authHeader() });
};

const getPaymentHeaders = () => {
  return axios.get(API_URLU + 'cfspaymentheaders-vw', { headers: authHeader() });
};

const getPaymentDetails = () => {
  return axios.get(API_URLU + 'payment-details', { headers: authHeader() });
};

const getPaymentHeaderByHeaderId = (phdId) => {
  return axios.get(API_URLU + 'payment-headers/' + phdId, {
    headers: authHeader()
  });
};

const getAllPaymentHeaders = () => {
  return axios.get(API_URLU + 'payment-headers', { headers: authHeader() });
};

const postPaymentHeaders = (data) => {
  return axios.post(API_URLU + 'payment-headers', data, { headers: authHeader() });
};

const postGltranHeaders = (data) => {
  return axios.post(API_URLU + 'gltran-headers', data, { headers: authHeader() });
};

const postGltranDetails = (data) => {
  return axios.post(API_URLU + 'gltran-details', data, { headers: authHeader() });
};

const putPaymentHeaders = (phdId, data) => {
  return axios.put(API_URLU + 'payment-headers/' + phdId, data, { headers: authHeader() });
};

const postPaymentDetails = (data) => {
  return axios.post(API_URLU + 'payment-details', data, { headers: authHeader() });
};

const getInvoiceHeaders = () => {
  return axios.get(API_URLU + 'cfsinvoiceheaders-vw', { headers: authHeader() });
};

const getPaymentDetailsByHeaderId = (phdId) => {
  return axios.get(API_URLU + 'payment-details/' + phdId, {
    headers: authHeader()
  });
};

const getInvoiceTransactionCodes = () => {
  return axios.get(API_URLU + 'cfsinvoice-codes', { headers: authHeader() });
};

const getPaymentTransactionCodes = () => {
  return axios.get(API_URLU + 'cfspayment-codes', { headers: authHeader() });
};

const getPaymentModes = () => {
  return axios.get(API_URLU + 'cfspayment-modes', { headers: authHeader() });
};

const getOurRef = () => {
  return axios.get(API_URLU + 'cfspayments-ourref', { headers: authHeader() });
};

const getMainAccounts = () => {
  return axios.get(API_URLU + 'cfsmain-acc', { headers: authHeader() });
};

const getSubAccountsByMain = (data) => {
  return axios.get(API_URLU + 'cfssub-acc?accountCode=' + data.accountCode + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getCustBank = (data) => {
  return axios.get(API_URLU + 'cfs-custbanks?cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const getBranches = () => {
  return axios.get(API_URLU + 'branch', { headers: authHeader() });
};

const getDepartments = () => {
  return axios.get(API_URLU + 'get-departments', { headers: authHeader() });
};

const getPaymentReport = (data) => {
  return axios.get(
    API_URLU +
    'purchase-report?reportFormat=' +
    data.reportFormat +
    '&repName=' +
    data.repName +
    '&cmpId=' +
    data.cmpId +
    '&phdId=' +
    data.phdId,
    {
      headers: authHeader()
    }
  );
};

const approvePaymentHeader = (data) => {
  return axios.get(
    API_URLU +
    'approve-payment-header?invoicePhdId=' +
    data.invoicePhdId +
    '&phdID=' +
    data.phdID +
    '&docDate=' +
    data.docDate +
    '&cmpId=' +
    data.cmpId +
    '&user=' +
    data.user +
    '&tranCode=' +
    data.tranCode +
    '&lcAmount=' +
    data.lcAmount +
    '&action=' +
    data.action,
    { headers: authHeader() }
  );
};

const getPaymentDocNumber = (data) => {
  return axios.get(
    API_URLU +
    'get-payment-doc-number?cmpId=' +
    data.cmpId +
    '&tranCode=' +
    data.tranCode +
    '&docDate=' +
    data.docDate +
    '&accountYear=' +
    data.accountYear,
    { headers: authHeader() }
  );
};

const getInvoiceBalance = (data) => {
  return axios.get(API_URLU + 'get-invoice-balance?phdId=' + data.phdId, {
    headers: authHeader()
  });
};

const getTranTypes = (cmpId) => {
  return axios.get(API_URLU + 'get-tran-types?cmpId=' + cmpId, { headers: authHeader() });
};
const getSaleFinTrans = (data) => {
  return axios.get(API_URLU + 'cmp-sale-fin-trans?sshId=' + data.sshId + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const genSaleFinTrans = (data) => {
  return axios.get(
    API_URLU +
    'gen-sale-fin-trans?sshId=' +
    data.sshId +
    '&cmpId=' +
    data.cmpId +
    '&saleDate=' +
    data.saleDate +
    '&username=' +
    data.username,

    {
      headers: authHeader()
    }
  );
};

const linkCustomerAccount = (data) => {
  return axios.get(API_URLU + 'link-debtor-subaccount?custCode=' + data.custCode + '&user=' + data.user + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const generateCustomerSubaccount = (data) => {
  return axios.get(API_URLU + 'generate-customer-subaccout?cmpId=' + data.cmpId + '&custCode=' + data.custCode + '&user=' + data.user, {
    headers: authHeader()
  });
};

const getUnbankedReceipts = (cmpId) => {
  return axios.get(API_URLU + 'get-unbanked-receipts?cmpId=' + cmpId, { headers: authHeader() });
};

const getBankingTranCode = (cmpId) => {
  return axios.get(API_URLU + 'get-banking-trancode/' + cmpId, { headers: authHeader() });
};
const getBankingDocNumber = (data) => {
  return axios.get(API_URLU + 'get-banking-doc-number?tranCode=' + data.tranCode + '&docDate=' + data.docDate + '&cmpId=' + data.cmpId, {
    headers: authHeader()
  });
};

const postReceiptBankHeader = (data) => {
  return axios.post(API_URLU + 'bank-receipt-header', data, { headers: authHeader() });
};

const postReceiptBankDetails = (data) => {
  return axios.post(API_URLU + 'receipt-banking-details', data, { headers: authHeader() });
};

const getUpdate = (data) => {
  return axios.get(
    API_URLU +
    'update-user-rights?approve=' +
    data.approve +
    '&initiate=' +
    data.initiate +
    '&sstId=' +
    data.sstId +
    '&username=' +
    data.username,
    {
      headers: authHeader()
    }
  );
};
const updateCompSystems = (data) => {
  return axios.get(
    API_URLU +
    'update-comp-system?cmpId=' +
    data.cmpId +
    '&sstId=' +
    data.sstId +
    '&username=' +
    data.createdBy +
    '&createdDate=' +
    data.createdDate,
    { headers: authHeader() }
  );
};

const getUserAllSubSystems = (data) => {
  return axios.get(API_URLU + 'user-all-sub-systems?cmpId=' + data.cmpId + '&username=' + data.username, {
    headers: authHeader()
  });
};

const getUserUnsubscribedSystems = (data) => {
  return axios.get(
    API_URLU +
    "user-unsubscribed-systems?cmpId=" +
    data.cmpId +
    "&username=" +
    data.username,
    { headers: authHeader() }
  );
};

const getCompUSystems = (id) => {
  return axios.get(API_URLU + "company-unsubscribed-systems?cmpId=" + id, {
    headers: authHeader(),
  });
};

const deleteUserComp = (id) => {
  return axios.delete(API_URLU + "ucompany/" + id, { headers: authHeader() });
};

const updateUserComp = (data) => {
  return axios.get(
    API_URLU +
    "update-comp-user?ucmId=" +
    data.ucmId +
    "&adminYN=" +
    data.adminYN,
    { headers: authHeader() }
  );
};

const getUserBycmp = (id) => {
  return axios.get(API_URLU + "company-users?cmpId=" + id, {
    headers: authHeader(),
  });
};

const getMasterUserComp = (id) => {
  return axios.get(API_URLU + "master-user-companies?userId=" + id, {
    headers: authHeader(),
  });
};

const getUserByName = (username) => {
  return axios.get(API_URLU + "userName/" + username, {
    headers: authHeader(),
  });
};


const getGeneralSettingsByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'gen-settings-id/' + cmpId, {
    headers: authHeader()
  });
};

const getSacMembers = (cmpId) => {
  return axios.get(API_URLU + 'sac-members-id/' + cmpId, {
    headers: authHeader()
  });
};

const getSacMembersById = (memberSysId) => {
  return axios.get(API_URLU + 'sac-members-sysId/' + memberSysId, {
    headers: authHeader()
  });
};

const getProvLoansById = (splId) => {
  return axios.get(API_URLU + 'prov-loans-id/' + splId, {
    headers: authHeader()
  });
};

const getApprLoansById = (salId) => {
  return axios.get(API_URLU + 'appr-loans-id/' + salId, {
    headers: authHeader()
  });
};


const postSacMembers = async (data) => {
  try {
    const response = await axios.post(API_URLU + 'sac-members', data, { headers: authHeader() });
    return response.data;
  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 409 && data.error === 'duplicate_key') {
        throw new Error(data.message || 'Email already exists in this sacco.');
      }

      if (status === 400 && data.error === 'data_integrity_violation') {
        throw new Error(data.message || 'Data integrity violation occurred.');
      }

      if (status === 500 && data.error === 'internal_server_error') {
        throw new Error(data.message || 'An unexpected error occurred.');
      }
    }
    throw new Error('An error occurred. Please try again.');
  }
};


const putSacMembers = (memberSysId, data) => {
  return axios.put(API_URLU + 'sac-members/' + memberSysId, data, { headers: authHeader() });
};

const getMemberCode = (data) => {
  return axios.get(
    API_URLU +
    'get-mem-code?cmpId=' +
    data.cmpId,
    { headers: authHeader() }
  );
};

const getBatchNumber = (data) => {
  return axios.get(
    API_URLU +
    'get-batch-number?cmpId=' +
    data.cmpId,
    { headers: authHeader() }
  );
};

const updateHeaderTotals = (data) => {
  return axios.get(
    API_URLU +
    'update-header-amount?sahSystemId=' +
    data.sahSystemId,
    { headers: authHeader() }
  );
};

const genSacSerials = (data) => {
  return axios.get(
    API_URLU +
    'gen-sac-serials?cmpId=' +
    data.cmpId,
    { headers: authHeader() }
  );
};

const usersPreSelfService = (data) => {
  return axios.get(
    API_URLU + 'users-pre-selfservice?cmpId=' + data.cmpId + '&user=' + data.user + '&module=' + data.module, { headers: authHeader() });
};

const companySystemLink = (data) => {
  return axios.get(
    API_URLU + 'company-system-link?cmpId=' + data.cmpId + '&sstId=' + data.sstId + '&email=' + data.email, { headers: authHeader() });
};

const adminSystemLink = (data) => {
  return axios.get(
    API_URLU + 'admin-system-link?cmpId=' + data.cmpId + '&sstId=' + data.sstId + '&usrId=' + data.usrId + '&email=' + data.email, { headers: authHeader() });
};

const putGeneralSettings = (cmpId, data) => {
  return axios.put(API_URLU + 'gen-settings/' + cmpId, data, { headers: authHeader() });
};

const getLoanTypes = (cmpId) => {
  return axios.get(API_URLU + 'loan-types/' + cmpId, {
    headers: authHeader()
  });
};

const getContributionTypes = (cmpId) => {
  return axios.get(API_URLU + 'contribution-types/' + cmpId, {
    headers: authHeader()
  });
};

const getChargeTypes = (cmpId) => {
  return axios.get(API_URLU + 'charge-types/' + cmpId, {
    headers: authHeader()
  });
};

const postLoanTypes = (data) => {
  return axios.post(API_URLU + 'loan-types', data, { headers: authHeader() });
};

const postShareTypes = (data) => {
  return axios.post(API_URLU + 'contribution-types', data, { headers: authHeader() });
};

const postChargeTypes = (data) => {
  return axios.post(API_URLU + 'charge-types', data, { headers: authHeader() });
};

const getLoanTypesById = (sysLoanTypeId) => {
  return axios.get(API_URLU + 'loan-types-id/' + sysLoanTypeId, {
    headers: authHeader()
  });
};

const getShareTypesById = (sysContribId) => {
  return axios.get(API_URLU + 'contribution-types-id/' + sysContribId, {
    headers: authHeader()
  });
};

const getChargeTypesById = (sysChrgId) => {
  return axios.get(API_URLU + 'charge-types-id/' + sysChrgId, {
    headers: authHeader()
  });
};

const putLoanTypes = (sysLoanTypeId, data) => {
  return axios.put(API_URLU + 'loan-types/' + sysLoanTypeId, data, { headers: authHeader() });
};

const putShareTypes = (sysContribId, data) => {
  return axios.put(API_URLU + 'contribution-types/' + sysContribId, data, { headers: authHeader() });
};
const putChargeTypes = (sysChrgId, data) => {
  return axios.put(API_URLU + 'charge-types/' +sysChrgId, data, { headers: authHeader() });
};

const delLoanType = (sysLoanTypeId) => {
  return axios.delete(API_URLU + 'loan-types/' + sysLoanTypeId, { headers: authHeader() });
};

const delShareTypes = (sysContribId) => {
  return axios.delete(API_URLU + 'contribution-types/' + sysContribId, { headers: authHeader() });
};

const delChargeTypes = (sysChrgId) => {
  return axios.delete(API_URLU + 'charge-types/' + sysChrgId, { headers: authHeader() });
};

const getSaccoControlsByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'sac-controls/' + cmpId, {
    headers: authHeader()
  });
};

const putSaccoControls = (sysCtrlId, data) => {
  return axios.put(API_URLU + 'sac-controls/' + sysCtrlId, data, { headers: authHeader() });
};

const getSacMembersByEmailandCmpId = (email, cmpId) => {
  return axios.get(API_URLU + 'sac-members-email-cmpid/' + email + '/' + cmpId, {
    headers: authHeader()
  });
};

const getSacMembersByEmail = (email) => {
  return axios.get(API_URLU + 'sac-members-email/' + email, {
    headers: authHeader()
  });
};

const getPendingMemApplications = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'pending-mem-applications/' + cmpId + '/' + memberCode, {
    headers: authHeader(),
  });
};

const getApprovedMemApplications = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'approved-mem-applications/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getRejectedMemApplications = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'rejected-mem-applications/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getCompletedMemApplications = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'completed-mem-applications/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getSacLoanGuarantors = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'sac-loan-guarantorsvw/' + cmpId+ '/' + memberCode, {
    headers: authHeader()
  });
};

const getPendingSaccoApplications = (cmpId) => {
  return axios.get(API_URLU + 'pending-applications/' + cmpId , {
    headers: authHeader(),
  });
};

const getApprovedSaccoApplications = (cmpId) => {
  return axios.get(API_URLU + 'approved-applications/' + cmpId , {
    headers: authHeader()
  });
};

const getRejectedSaccoApplications = (cmpId) => {
  return axios.get(API_URLU + 'rejected-applications/' + cmpId , {
    headers: authHeader()
  });
};

const getCompletedSaccoApplications = (cmpId) => {
  return axios.get(API_URLU + 'completed-applications/' + cmpId , {
    headers: authHeader()
  });
};

const getTotalMemberLoanNumber = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'total-member-loans/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getTotalMemberLoanAmount = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'total-loan-amount/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getTotalMemberLoanBalance = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'total-loan-balance/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getTotalActiveLoans = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'total-active-loans/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const postProvLoans = (data) => {
  return axios.post(API_URLU + 'prov-loans', data, { headers: authHeader() });
};

const putProvLoans = (splId, data) => {
  return axios.put(API_URLU + 'prov-loans/' + splId, data, { headers: authHeader() });
};

const putApprLoans = (salId, data) => {
  return axios.put(API_URLU + 'appr-loans/' + salId, data, { headers: authHeader() });
};

const getPaymentsWithBalance = () => {
  return axios.get(API_URLU + 'payments-wbalance', { headers: authHeader() });
};

const approveMemberLoans = (data) => {
  return axios.get(
    API_URLU + 'approve-member-loans?splId=' + data.splId + '&cmpId=' + data.cmpId + '&rejectedYn=' + data.rejectedYn, { headers: authHeader() });
};

const getBankHeadersBySacco = (cmpId) => {
  return axios.get(API_URLU + 'sac-bank-headers-cmpid/' + cmpId , {
    headers: authHeader()
  });
};

const getActiveBankHeadersBySacco = (cmpId) => {
  return axios.get(API_URLU + 'sac-actbank-headers-cmpid/' + cmpId , {
    headers: authHeader()
  });
};

const postBankHeaders = (data) => {
  return axios.post(API_URLU + 'sac-bank-headers', data, { headers: authHeader() });
};

const putBankHeaders = (sysBankId, data) => {
  return axios.put(API_URLU + 'sac-bank-headers/' + sysBankId, data, { headers: authHeader() });
};

const getBankHeadersById = (sysBankId) => {
  return axios.get(API_URLU + 'sac-bank-headers-id/' +sysBankId, {
    headers: authHeader()
  });
};

const delBankHeaders = (sysBankId) => {
  console.log(sysBankId);
  return axios.delete(API_URLU + 'sac-bank-headers/' + sysBankId, { headers: authHeader() });
};

const getBankBranchesBySacco = (cmpId) => {
  return axios.get(API_URLU + 'sac-bank-branches-cmpid/' + cmpId , {
    headers: authHeader()
  });
};

const postBankBranches = (data) => {
  return axios.post(API_URLU + 'sac-bank-branches', data, { headers: authHeader() });
};

const putBankBranches = (sysBranchId, data) => {
  return axios.put(API_URLU + 'sac-bank-branches/' + sysBranchId, data, { headers: authHeader() });
};

const getBankBranchesById = (sysBranchId) => {
  return axios.get(API_URLU + 'sac-bank-branches-id/' + sysBranchId, {
    headers: authHeader()
  });
};

const getBankBranchesByHeader = (bankHeaderCode, cmpId) => {
  return axios.get(API_URLU + 'sac-bank-branches-byheader-cmpid/' + bankHeaderCode + '/' + cmpId, {
    headers: authHeader()
  });
};

const getActBankBranchesByHeader = (bankHeaderCode, cmpId) => {
  return axios.get(API_URLU + 'sac-actbank-branches-byheader-cmpid/' + bankHeaderCode + '/' + cmpId, {
    headers: authHeader()
  });
};

const getBankBranchesByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'sac-bank-branches-cmpid/' + cmpId, {
    headers: authHeader()
  });
};

const delBankBranches = (sysBranchId) => {
  return axios.delete(API_URLU + 'sac-bank-branches/' + sysBranchId, { headers: authHeader() });
};



const getSacCurrencies = (cmpId) => {
  return axios.get(API_URLU + 'company-currencies/' + cmpId, {
    headers: authHeader()
  });
};

const getCurrencyCodesById = (crrId) => {
  return axios.get(API_URLU + 'company-currencies-id/' + crrId, {
    headers: authHeader()
  });
};

const postCurrencyCodes = (data) => {
  return axios.post(API_URLU + 'all-currencies', data, { headers: authHeader() });
};

const putCurrencyCodes = (crrId, data) => {
  return axios.put(API_URLU + 'all-currencies/' + crrId, data, { headers: authHeader() });
};

const delCurrencyCodes = (crrId) => {
  return axios.delete(API_URLU + 'all-currencies/' + crrId, { headers: authHeader() });
};

const postLoanGuarantors = (data) => {
  return axios.post(API_URLU + 'sac-loan-guarantors', data, { headers: authHeader() });
};

const postLoanGuarantorsSendEmail = (guarantorEmail, memberNames, companyName, data) => {
  return axios.post(API_URLU + 'sac-loan-guarantors-email/'+ guarantorEmail + '/' + memberNames + '/' + companyName, data, { headers: authHeader() });
};

const putLoanGuarantors = (sysGuarantorId, data) => {
  return axios.put(API_URLU + 'sac-loan-guarantors/' + sysGuarantorId, data, { headers: authHeader() });
};

const getLoanGuarantorsbyLoan = (splId) => {
  return axios.get(API_URLU + 'sac-loan-guarantors-loan/' + splId, {
    headers: authHeader()
  });
};

const delLoanGuarantors = (sysGuarantorId) => {
  return axios.delete(API_URLU + 'sac-loan-guarantors/' + sysGuarantorId, { headers: authHeader() });
};

const getPendingSaccoSavingsHeaders = (cmpId) => {
  return axios.get(API_URLU + 'pending-savings-headers-cmpid/' + cmpId , {
    headers: authHeader(),
  });
};

const getApprovedSaccoSavingsHeaders = (cmpId) => {
  return axios.get(API_URLU + 'approved-savings-headers-cmpid/' + cmpId , {
    headers: authHeader(),
  });
};

const getSaccoSavingsDetailsByHeaders = (sahSystemId) => {
  return axios.get(API_URLU + 'sac-savings-details-header-id/' + sahSystemId , {
    headers: authHeader(),
  });
};

const postSacSavings = (data) => {
  return axios.post(API_URLU + 'sac-savings-headers', data, { headers: authHeader() });
};

const postSacSavingsDetails = (data) => {
  return axios.post(API_URLU + 'sac-savings-details', data, { headers: authHeader() });
};

const getSavingsHeadersById = (sahSystemId) => {
  return axios.get(API_URLU + 'sac-savings-headers-id/' + sahSystemId, {
    headers: authHeader()
  });
};

const getSavingsDetailsById = (sadSystemId) => {
  return axios.get(API_URLU + 'sac-savings-details-id/' + sadSystemId, {
    headers: authHeader()
  });
};

const putSavingsHeaders = (sahSystemId, data) => {
  return axios.put(API_URLU + 'sac-savings-headers/' + sahSystemId, data, { headers: authHeader() });
};

const putSavingsDetails = (sadSystemId, data) => {
  return axios.put(API_URLU + 'sac-savings-details/' + sadSystemId, data, { headers: authHeader() });
};

const delMemberSavings = (sadSystemId) => {
  return axios.delete(API_URLU + 'sac-savings-details/' + sadSystemId, { headers: authHeader() });
};

const getPendGuaranteeRequests = (cmpId) => {
  return axios.get(API_URLU + 'sac-pending-guarantee-requests/' + cmpId , {
    headers: authHeader(),
  });
};

const getAppRejGuaranteeRequests = (cmpId) => {
  return axios.get(API_URLU + 'sac-apprej-guarantee-requests/' + cmpId , {
    headers: authHeader(),
  });
};

const getMemPendGuaranteeRequests = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'mem-pending-guarantee-requests/' + cmpId +'/'+ memberCode, {
    headers: authHeader(),
  });
};

const getMemAppRejGuaranteeRequests = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'mem-apprej-guarantee-requests/' + cmpId +'/'+ memberCode, {
    headers: authHeader(),
  });
};

const getGuaranteeRequestsById = (sysGuarantorId) => {
  return axios.get(API_URLU + 'sac-loan-guarantors-id/' + sysGuarantorId, {
    headers: authHeader(),
  });
};

const postSacMembersUpload = (formData) => {
  return axios.post(API_URLU + 'save-sac-members-csv', formData, 
    { 
      headers: authHeader(),
      "Content-Type": "multipart/form-data",
     });
};

const postSacMemberSavingsUpload = (formData) => {
  return axios.post(API_URLU + 'save-sac-member-savings-csv', formData, 
    { 
      headers: authHeader(),
      "Content-Type": "multipart/form-data",
     });
};

const updatebankBranchCode = (data) => {
  return axios.get(
    API_URLU +
    'update-branch-bank-code?sysBankId=' +
    data.sysBankId ,
    { headers: authHeader() }
  );
};

const getActiveLoanTypes = (cmpId) => {
  return axios.get(API_URLU + 'active-loan-types/' + cmpId, {
    headers: authHeader()
  });
};

const getActiveContributionTypes = (cmpId) => {
  return axios.get(API_URLU + 'active-contrib-types/' + cmpId, {
    headers: authHeader()
  });
};

const getActiveChargeTypes = (cmpId) => {
  return axios.get(API_URLU + 'active-charge-types/' + cmpId, {
    headers: authHeader()
  });
};

const getMemberSaccoSavings = (cmpId, memberCode) => {
  return axios.get(API_URLU + 'member-sacco-savings/' + cmpId + '/' + memberCode, {
    headers: authHeader()
  });
};

const getAcceptedLoanGuarantorsbyLoan = (splId) => {
  return axios.get(API_URLU + 'accepted-loan-guarantors-loan/' + splId, {
    headers: authHeader()
  });
};

const acceptLoanGuarantee = (sysGuarantorId, guarantorEmail, memberNames, companyName, data) => {
  return axios.put(API_URLU + 'approve-sac-loan-guarantors/' + sysGuarantorId + '/' + guarantorEmail + '/' + memberNames + '/' +
     companyName, data, { headers: authHeader() });
};

const declineLoanGuarantee = (sysGuarantorId, guarantorEmail, memberNames, companyName, data) => {
  return axios.put(API_URLU + 'decline-sac-loan-guarantors/' + sysGuarantorId + '/' + guarantorEmail + '/' + memberNames + '/' +
     companyName, data, { headers: authHeader() });
};

const getActiveSacCurrencies = (cmpId) => {
  return axios.get(API_URLU + 'active-company-currencies/' + cmpId, {
    headers: authHeader()
  });
};

const getMemberSaccoLimits = (memberCode, cmpId) => {
  return axios.get(
    API_URLU + 'get-sacco-member-limit?memberCode=' + memberCode + '&cmpId=' + cmpId, { headers: authHeader() });
};

const getSchoolUserCompanies = (id) => {
  return axios.get(API_URLU + 'school-user-companies?userId=' + id, { headers: authHeader() });
};

const companyMenuLink = (data) => {
  return axios.get(
    API_URLU + 'link-cmp-menus?cmpId=' + data.cmpId + '&sstId=' + data.sstId, { headers: authHeader() });
};

const getSchoolStudents = (cmpId) => {
  return axios.get(API_URLU + 'school-students-cmpid/' + cmpId, {
    headers: authHeader()
  });
};

const getStudentCode = (data) => {
  return axios.get(
    API_URLU +
    'get-student-code?cmpId=' +
    data.cmpId,
    { headers: authHeader() }
  );
};

const postSchoolStudents = (data) => {
  return axios.post(API_URLU + 'school-students', data, { headers: authHeader() });
};

const putSchoolStudents = (studentId, data) => {
  return axios.put(API_URLU + 'school-students/' + studentId, data, { headers: authHeader() });
};

const getSchoolStudentsById = (studentId) => {
  return axios.get(API_URLU + 'school-students-id/' + studentId, {
    headers: authHeader()
  });
};

const linkSchoolUser = (data) => {
  return axios.get(
    API_URLU +
    'link-insurance-user?cmpId=' +
    data.cmpId +
    '&sstId=' +
    data.sstId +
    '&usrId=' +
    data.usrId +
    '&accessCodeId=' +
    data.accessCodeId,
    { headers: authHeader() }
  );
};

const postSchoolStudentsUpload = (formData, cmpId, uploadRefNo) => {
  return axios.post(API_URLU + 'upload-school-students-csv?cmpId=' + cmpId + '&uploadRefNo=' + uploadRefNo, formData, 
    { 
      headers: authHeader(),
      "Content-Type": "multipart/form-data",
     });
};

const reuploadSchoolStudentsUpload = (formData, cmpId, uploadRefNo) => {
  return axios.post(API_URLU + 'reupload-school-students-csv?cmpId=' + cmpId + '&uploadRefNo=' + uploadRefNo, formData, 
    { 
      headers: authHeader(),
      "Content-Type": "multipart/form-data",
     });
};

const genUploadReferenceNo = () => {
  return axios.get(API_URLU + 'get-upload-ref-no', {
    headers: authHeader()
  });
};

const getAcceptedStudentUploads = (cmpId, uploadRefNo) => {
  return axios.get(API_URLU + 'accepted-student-uploads/' + cmpId + '/' + uploadRefNo, {
    headers: authHeader()
  });
};

const getRejectedStudentUploads = (cmpId, uploadRefNo) => {
  return axios.get(API_URLU + 'rejected-student-uploads/' + cmpId + '/' + uploadRefNo, {
    headers: authHeader()
  });
};

const validateStudentUploads = (uploadRefNo, cmpId) => {
  return axios.get(API_URLU + 'validate-students-upload/' + uploadRefNo + '/' + cmpId, {
    headers: authHeader()
  });
};

const postAcceptedSchoolStudentUploads = (data) => {
  return axios.post(API_URLU + 'save-accepted-students?cmpId=' + data.cmpId + '&uploadRefNo=' + data.uploadRefNo 
    + '&cmpShortName=' + data.cmpShortName, { headers: authHeader() });
};

const emailStudentsWithoutAccounts = (data) => {
  return axios.post(API_URLU + 'email-students-without-accounts?cmpId=' + data.cmpId, { headers: authHeader() });
};

const linkUnlinkedStudents = (data) => {
  return axios.post(API_URLU + 'link-unlinked-students?cmpId=' + data.cmpId + '&sstId=' + data.sstId 
    + '&accessCodeId=' + data.accessCodeId, { headers: authHeader() });
};

const getSchoolReports = () => {
  return axios.get(API_URLU + "school-ischool-reports", {
    headers: authHeader(),
  });
};

const runSchoolReport = (dts) => {
  return axios.get(
    API_URLU +
      "school-report?reportFormat=" +
      dts.reportFormat +
      "&repName=" +
      dts.repName +
      "&cmpId=" +
      dts.cmpId +
      "&status=" +
      dts.status ,
    { headers: authHeader() }
  );
};

const getStudentListingReport = (dts) => {
  return axios.get(
    API_URLU +
      "get-student-listing-report?cmpId=" +
      dts.cmpId +
      "&status=" +
      dts.status,
    { headers: authHeader() }
  );
};

export default {
  getUserById,
  getPendingSales,
  postSale,
  delSale,
  putSale,
  getSalesByDate,
  getSalesByShop,
  getUserShops,
  getDaySales,
  getUserSales,
  getAllSales,
  getUsers,
  postUser,
  getCompById,
  getCompanies,
  postComp,
  getSystemById,
  getSystems,
  postSystem,
  postUserComp,
  postUserSystems,
  getUserComp,
  getCompSystems,
  getUserCompSystems,
  getUserCompUSystems,
  getCustomerById,
  getCustomers,
  postCustomer,
  putCustomer,
  getEmployeeById,
  getEmployeeByUsername,
  getEmployees,
  getPagedEmployees,
  postEmployee,
  putEmployee,
  getClassification,
  getGeneral,
  getFiles,
  saveInvoice,
  getInvoiceInfo,
  getScheduledLeaves,
  postLeaveSchedule,
  getLeaveAccruals,
  getLeaveApplications,
  postLeaveApplication,
  getLeaveTransactions,
  getLeaveRejections,
  getLeaveTypes,
  getReturnDate,
  uploadFile,
  uploadExcel,
  postTempBranch,
  getTempBranch,
  getPastDays,
  postDay,
  getDaysStatus,
  putDay,
  getMaxDate,
  getSaleStatus,
  updatePass,
  updateUser,
  updateUserImg,
  getApprovedSales,
  getAdminSalesByDate,
  getAllShops,
  getAdminSalesByShop,
  getStockCodes,
  getQuoteId,
  getQuoteInfo,
  delQuote,
  getQuoteReport,
  postQuoteHeader,
  postQuoteDetails,
  genCombinedQuote,
  getCombinedQuotes,
  archCombQuote,
  listSingleQuoutes,
  listCombinedQuoutes,
  companyVatRates,
  checkVatDates,
  postVatRates,
  delVatRate,
  putVatRate,
  companyStdRates,
  postStandardRates,
  delStdRate,
  putStdRate,
  companyGenRates,
  postGeneralRates,
  delGenRate,
  putGenRate,
  currentPeriods,
  pastPeriods,
  closePeriod,
  postNewPeriod,
  putIstPeriod,
  getCompanyProducts,
  getProductDetails,
  postIstProducts,
  putIstProducts,
  delIstProduct,
  getCompanySuppliers,
  getSupplierDetails,
  postIstSuppliers,
  putIstSuppliers,
  getSupplierStocks,
  getSupplerProductDetails,
  putIstSupplierProducts,
  getCombinedSingle,
  updateStockQuote,
  postIstSupplierProducts,
  getCompanyTariffPeriods,
  getTariffCashRates,
  getRateDetails,
  putCashRateDetails,
  getCheckOffMarkupPercs,
  getMarkupPercDetails,
  putMarkupDetails,
  closeTariffPeriod,
  getTrpHpDeposit,
  getHPDepositDetails,
  putHpDepositDetails,
  getTrpDiscounts,
  getDiscountDetails,
  putDiscountDetails,
  getTrpInstalMonths,
  getInstalMonthsDetails,
  putInstalMonths,
  getHpMarkupRates,
  getMarkupDetails,
  putMarkupRates,
  getHpMarkupPercs,
  getMarkupPerc,
  putMarkupPercs,
  copyPeriods,
  getProductHist,
  getCompanyStocks,
  postCashRateDetails,
  delCashRate,
  postMarkupDetails,
  delMarkup,
  postHpDepositDetails,
  delHpDepositDetails,
  postDiscountDetails,
  delDiscountDetails,
  postInstalMonths,
  delInstalMonths,
  postMarkupRates,
  delMarkupRate,
  getPriceCataloq,
  getJointYn,
  getJointStockCodes,
  getStockCatalogue,
  getActiveStocks,
  getMinDate,
  getStockCheckOff,
  getSupplierPriceList,
  getSupplierPastPriceList,
  updatePriceCatalogue,
  addNewPriceListItem,
  updatePriceList,
  UpdateAllPrices,
  getJointStocks,
  addJointStocks,
  getUserRights,
  approveVATRates,
  approveSTDRates,
  approveGENRates,
  approvePeriod,
  allPeriods,
  clearStockPrices,
  updateStockPrices,
  updateTariffPeriod,
  approvetariffPeriod,
  getCataloguePeriods,
  inteGrateWithKct,
  getCompanyStockCodes,
  genNoneStockQuote,
  listNonStockQuotes,
  approveCashRate,
  approveCheckOff,
  getActiveEndDate,
  approveStock,
  getMenuLevels,
  getAddTempItem,
  getPoH,
  getPoHVW,
  getReqH,
  getPoD,
  getReqD,
  getPolNo,
  postPoH,
  postPoD,
  getReqSummary,
  getPoSummary,
  getPohApproval,
  getPurchaseReport,
  getCustomerByCmpId,
  genCombQuoteHeader,
  genCombNoneStockQuote,
  listCombNonStockQuotes,
  getCombQuoteReport,
  postGaaH,
  postGaaD,
  getUpdatePoDetails,
  getPoNotInGaa,
  getGaaHVW,
  getGaaHVWItems,
  getUserBranches,
  generateCombinedNonStockQuote,
  genCombQuoteNoneStockDetails,
  postGap,
  postStkTransH,
  postStkTransD,
  getShopTransfers,
  getShopTransferDetails,
  getTransferInvoiceReport,
  getSupplierEmail,
  sendLpoMail,
  getReceiptTranCodes,
  getPaymentModes,
  getCustomerCodes,
  getPolicyInformation,
  getAddress,
  getAllBankAccounts,
  getDocDetails,
  docAvailable,
  postReceiptHeader,
  putReceiptHeader,
  postReceiptDetails,
  putReceiptDetails,
  getReceiptDetails,
  getCompanyBanks,
  getReceiptHeaderApprovalStatus,
  approveReceiptHeader,
  saleItems,
  postSalesHeader,
  postSalesDetails,
  postSalesParticular,
  getSalesHeader,
  getCustomerByCmpIdAndId,
  getGapItemsByGaaNo,
  poReports,
  getPoReportDetails,
  getPurchaseReport2,
  updateMialSent,
  cancelPO,
  getSaleTypes,
  companyReceipts,
  getSelectedReceiptDetails,
  getAllCreditAccounts,
  getPaymentHeaders,
  getPaymentDetailsByHeaderId,
  getInvoiceTransactionCodes,
  getPaymentTransactionCodes,
  getInvoiceHeaders,
  getOurRef,
  getMainAccounts,
  getSubAccountsByMain,
  getCustBank,
  getBranches,
  getDepartments,
  postPaymentDetails,
  postPaymentHeaders,
  putPaymentHeaders,
  getPaymentHeaderByHeaderId,
  postGltranHeaders,
  postGltranDetails,
  getPaymentReport,
  getPaymentDetails,
  getAllPaymentHeaders,
  approvePaymentHeader,
  getPaymentDocNumber,
  getInvoiceBalance,
  findPaymentModes,
  getTranTypes,
  linkCustomerAccount,
  getLinkedCustomerAccounts,
  getUnbankedReceipts,
  getCustomerSubaccounts,
  generateCustomerSubaccount,
  getBankingTranCode,
  getBankingDocNumber,
  postReceiptBankHeader,
  postReceiptBankDetails,
  getGaaDByGaaNo,
  getSaleFinTrans,
  genSaleFinTrans,
  getSalesDetailsBySshId,
  getSalesParticularBySshId,
  getUpdate,
  updateCompSystems,
  getUserAllSubSystems,
  getUserUnsubscribedSystems,
  getCompUSystems,
  deleteUserComp,
  updateUserComp,
  getUserBycmp,
  getMasterUserComp,
  getUserByName,
  getSacMembers,
  postSacMembers,
  getMemberCode,
  usersPreSelfService,
  getGeneralSettingsByCmpId,
  putGeneralSettings,
  getSacMembersById,
  putSacMembers,
  getLoanTypes,
  getChargeTypes,
  getContributionTypes,
  postLoanTypes,
  postShareTypes,
  postChargeTypes,
  getLoanTypesById,
  getShareTypesById,
  getChargeTypesById,
  putLoanTypes,
  putShareTypes,
  putChargeTypes,
  delLoanType,
  delShareTypes,
  delChargeTypes,
  getSaccoControlsByCmpId,
  putSaccoControls,
  getPendingMemApplications,
  getApprovedMemApplications,
  getRejectedMemApplications,
  getCompletedMemApplications,
  getPendingSaccoApplications,
  getApprovedSaccoApplications,
  getRejectedSaccoApplications,
  getCompletedSaccoApplications,
  postProvLoans,
  getProvLoansById,
  getApprLoansById,
  putProvLoans,
  putApprLoans,
  getSacMembersByEmailandCmpId,
  getSacMembersByEmail,
  getTotalMemberLoanNumber,
  getPaymentsWithBalance,
  approveMemberLoans,
  getBankBranchesBySacco,
  getBankHeadersBySacco,
  postBankHeaders,
  putBankHeaders,
  getBankHeadersById,
  putBankBranches,
  postBankBranches,
  getBankBranchesByHeader,
  getBankBranchesById,
  getBankBranchesByCmpId,
  delBankBranches,
  delBankHeaders,
  getSacLoanGuarantors,
  getSacCurrencies,
  getCurrencyCodesById,
  postCurrencyCodes,
  putCurrencyCodes,
  delCurrencyCodes,
  getTotalMemberLoanBalance,
  getTotalMemberLoanAmount,
  getTotalActiveLoans,
  postLoanGuarantors,
  getLoanGuarantorsbyLoan,
  delLoanGuarantors,
  genSacSerials,
  companySystemLink,
  adminSystemLink,
  getPendingSaccoSavingsHeaders,
  getApprovedSaccoSavingsHeaders,
  getSaccoSavingsDetailsByHeaders,
  getBatchNumber,
  postSacSavings,
  postSacSavingsDetails,
  getSavingsDetailsById,
  putSavingsDetails,
  delMemberSavings,
  putSavingsHeaders,
  getSavingsHeadersById,
  getPendGuaranteeRequests,
  getAppRejGuaranteeRequests,
  getMemPendGuaranteeRequests,
  getMemAppRejGuaranteeRequests,
  updateHeaderTotals,
  getGuaranteeRequestsById,
  putLoanGuarantors,
  postSacMembersUpload,
  postSacMemberSavingsUpload,
  getActiveBankHeadersBySacco,
  getActBankBranchesByHeader,
  updatebankBranchCode,
  getActiveContributionTypes,
  getActiveLoanTypes,
  getActiveChargeTypes,
  getMemberSaccoSavings,
  getAcceptedLoanGuarantorsbyLoan,
  getSavingsUserComp,
  acceptLoanGuarantee,
  postLoanGuarantorsSendEmail,
  declineLoanGuarantee,
  getActiveSacCurrencies,
  getMemberSaccoLimits,
  getSchoolUserCompanies,
  companyMenuLink,
  getSchoolStudents,
  getStudentCode,
  postSchoolStudents,
  putSchoolStudents,
  getSchoolStudentsById,
  linkSchoolUser,
  postSchoolStudentsUpload,
  validateStudentUploads,
  getRejectedStudentUploads,
  getAcceptedStudentUploads,
  genUploadReferenceNo,
  reuploadSchoolStudentsUpload,
  postAcceptedSchoolStudentUploads,
  emailStudentsWithoutAccounts,
  linkUnlinkedStudents,
  getSchoolReports,
  runSchoolReport,
  getStudentListingReport,
};
